import { LabelDisplayedRowsArgs } from "@material-ui/core";

/**
 * 現在表示中の件数を表示するコンポーネントです。
 */
export const CustomLabelDisplayedRow: React.FC<LabelDisplayedRowsArgs> = ({
  from,
  to,
  count,
  page,
}) => {
  return (
    <p>
      {from} - {to} / {count} 件中 ({page + 1}ページ目)
    </p>
  );
};
